import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

interface ProtectedRouteProps {
  children: React.ReactElement;
  requireManager?: boolean;
  requireSalesperson?: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requireManager = false,
  requireSalesperson = false,
}) => {
  const { user, loading, isManager, isSalesperson } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  // Check manager requirement
  if (requireManager && !isManager) {
    // Redirect salespeople to their own detail page
    return <Navigate to={`/salesperson/${user.salespersonId}`} replace />;
  }

  // Check salesperson requirement
  if (requireSalesperson && !isSalesperson) {
    // Redirect managers to dashboard
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
